import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { StoreBadgesComponent } from './store-badges.component';
import { PaymentLogosComponent } from './payment-logos.component';
import { HubLink, hubFooterLinks } from '../hub/content';
import { LEGAL_LINKS } from '../legal/legal-slugs';
import { SHOW_PAYMENT_LOGOS } from '../site.config';

@Component({
    selector: 'site-footer',
    imports: [RouterLink, StoreBadgesComponent, PaymentLogosComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <footer class="mt-auto border-0 border-t border-solid border-surface-line bg-surface-alt" aria-labelledby="site-footer-title">
      <h2 id="site-footer-title" class="sr-only">Site alt bilgisi</h2>
      <div class="site-container grid gap-10 py-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div class="flex flex-col gap-[1rem]">
          <a routerLink="/" class="flex min-h-tap items-center gap-2 self-start font-bold text-ink no-underline">
            <img src="assets/logo.svg" alt="" width="28" height="28" class="h-7 w-7" loading="lazy" />
            <span class="text-lg">My PT</span>
          </a>
          <p class="max-w-sm text-sm text-ink-muted">Personal trainer'lar ve stüdyolar için ders, danışan ve ödeme takibi.</p>
          <site-store-badges />
        </div>
        <nav aria-labelledby="footer-product">
          <h3 id="footer-product" class="text-sm font-semibold">Ürün</h3>
          <ul role="list" class="mt-[0.75rem] flex flex-col gap-1 text-sm">
            @for (link of hubLinks; track link.path) {
              <li><a [routerLink]="link.path" class="inline-flex min-h-tap items-center text-ink-muted">{{ link.label }}</a></li>
            }
            <li><a routerLink="/fiyatlar" class="inline-flex min-h-tap items-center text-ink-muted">Fiyatlar</a></li>
            <li><a routerLink="/sss" class="inline-flex min-h-tap items-center text-ink-muted">Sık sorulan sorular</a></li>
            <li><a routerLink="/iletisim" class="inline-flex min-h-tap items-center text-ink-muted">İletişim</a></li>
            <li>
              <a routerLink="/iletisim" fragment="destek-formu" class="inline-flex min-h-tap items-center text-ink-muted">Destek</a>
            </li>
            <li><a routerLink="/auth/login" class="inline-flex min-h-tap items-center text-ink-muted">Giriş yap</a></li>
          </ul>
        </nav>
        <nav aria-labelledby="footer-legal">
          <h3 id="footer-legal" class="text-sm font-semibold">Yasal</h3>
          <ul role="list" class="mt-[0.75rem] flex flex-col gap-1 text-sm">
            @for (link of legalLinks; track link.slug) {
              <li>
                <a [routerLink]="'/' + link.slug" class="inline-flex min-h-tap items-center text-ink-muted">{{ link.label }}</a>
              </li>
            }
            <li><a routerLink="/hesap-silme" class="inline-flex min-h-tap items-center text-ink-muted">Hesap silme</a></li>
          </ul>
        </nav>
      </div>
      <div class="site-container flex flex-col gap-6 border-0 border-t border-solid border-surface-line py-8">
        @if (showPaymentLogos) {
          <site-payment-logos />
        }
        <p class="text-sm text-ink-subtle">© {{ year }} My PT. Tüm hakları saklıdır.</p>
      </div>
    </footer>
  `
})
export class SiteFooterComponent {
  hubLinks: readonly HubLink[] = hubFooterLinks();
  readonly legalLinks = LEGAL_LINKS;
  readonly year = new Date().getFullYear();
  readonly showPaymentLogos = SHOW_PAYMENT_LOGOS;
}
